import { CONFIG } from 'src/common/config'

const listeners = new Map()
let socket = null
let wsToken = null
let timer = null
let wsIntervalReconnect = CONFIG.WS.WS_INTERVAL_RECONNECT

const listenSocket = (e) => {
  const { text } = JSON.parse(e.data)
  const { message_type, content } = text
  if (listeners.has(message_type)) {
    try {
      listeners.get(message_type)(content)
    } catch (e) {
      console.error(`Error during callback from a websocket (${message_type})`, e)
    }
  }
}

const sendPing = () => {
  return new Promise((resolve, reject) => {
    WebsocketService.send({ action: 'ping' })

    const timeout = setTimeout(() => {
      wsIntervalReconnect = 0
      reject(new Error('Pong timeout'))
    }, CONFIG.WS.PONG_TIMEOUT)

    const onMessage = (event) => {
      const { text } = JSON.parse(event.data)
      if (text.message_type === 'pong') {
        clearTimeout(timeout)
        socket.removeEventListener('message', onMessage)
        resolve()
      }
    }

    socket.addEventListener('message', onMessage)
  })
}

const connectToWs = () => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    return
  }

  wsIntervalReconnect = CONFIG.WS.WS_INTERVAL_RECONNECT

  const urlWs = process.env.WS_DOMAIN || `wss://${location.hostname}/ws/`
  socket = new WebSocket(urlWs)

  socket.onopen = async () => {
    if (wsToken) {
      WebsocketService.send({
        message_type: 'signin',
        token: wsToken,
      })
    }

    try {
      while (socket && socket.readyState === WebSocket.OPEN) {
        await sendPing()
        await new Promise((resolve) => setTimeout(resolve, CONFIG.WS.PONG_INTERVAL))
      }
    } catch (error) {
      console.log('Error or ping timeout, closing socket:', error)
      if (socket) {
        socket.close()
      }
    }
  }

  socket.onmessage = listenSocket
  socket.onclose = () => reconnect()
  socket.onerror = () => reconnect()
}

function reconnect() {
  socket = null
  clearTimeout(timer)

  timer = setTimeout(() => connectToWs(), wsIntervalReconnect)
}

export const WebsocketService = {
  initWebsocket: (token = '') => {
    wsToken = token
    connectToWs()
  },

  close: () => {
    if (socket) {
      socket.close()
    }
  },

  updateToken: (token) => {
    wsToken = token
    if (socket && socket.readyState === WebSocket.OPEN) {
      WebsocketService.send({
        message_type: 'signin',
        token: wsToken,
      })
    }
  },

  send: (json) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(json))
    }
  },

  subscribeToSocketMessage: (messageType, callback) => {
    listeners.set(messageType, callback)
  },

  unsubscribeToSocketMessage: (messageType) => {
    listeners.delete(messageType)
  },
}
